<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="姓名" prop="nickname">
                        <Input
                            v-model="info.nickname"
                            :readonly="readonly"
                            :maxlength="256"
                            placeholder
                        ></Input>
                    </FormItem>
                    <FormItem label="手机号" prop="phone">
                        <Input
                            v-model="info.phone"
                            :readonly="readonly"
                            :maxlength="256"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="头像" prop="avatar">
                        <preview-upload
                            v-model="info.avatar"
                            :readonly="readonly"
                            :format="imgSuffix"
                        ></preview-upload>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="性别" prop="sex">
                        <Select
                            v-model="info.sex"
                            :readonly="readonly"
                            transfer
                            clearable
                            placeholder
                        >
                            <Option
                                v-for="(item, index) in genderList"
                                :value="item.id"
                                :key="index"
                            >{{item.text}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="汇报对象" prop="superior">
                        <form-lookup
                            v-model="info.superior"
                            :readonly="readonly"
                            placeholder
                            title="选择汇报对象"
                            textSymbol="nickname"
                            :modalHeight="540"
                            :modalWidth="800"
                            :options.sync="empOptions"
                        >
                            <select-inside multiple></select-inside>
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="岗位" prop="rids">
                        <form-lookup
                            v-model="info.rids"
                            :readonly="readonly"
                            placeholder="请选择岗位"
                            title="选择岗位"
                            :modalHeight="480"
                            :modalWidth="480"
                            :options="orgOptions"
                        >
                            <select-org></select-org>
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="说明" prop="remark">
                        <Input
                            type="textarea"
                            v-model="info.remark"
                            :readonly="readonly"
                            placeholder
                            :rows="3"
                            :maxlength="1000"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { tel } from '_u/validate'
import SelectInside from '_vc/select-inside'
import SelectOrg from './select-org'
import PreviewUpload from '_c/preview-upload'
import { roleList } from '@/api/user-manager'
import { userAdd, userUpdate, userView } from '@/api/sys-user'
import Enum from '_u/enum'

export default {
    name: 'FormCustomer',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {
        SelectInside,
        SelectOrg,
        PreviewUpload
    },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            imgSuffix: this.$config.upload.imgSuffix,
            info: {
                id: this.id,
                avatar: "", // 头像
                nickname: '', // 姓名
                phone: '', // 手机号
                sex: '', // 性别
                superior: '', // 汇报对象
                rids: '', // 岗位
                remark: '', // 说明
                ver: '' // 版本号
            },
            gender: Enum.get('sex'),
            empOptions: [],
            orgOptions: []
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can('update') : this.$can('add')
        },

        readonly() {
            return !this.canSave
        },

        ruleValidate() {
            return {
                nickname: [{ required: true, message: '姓名必填' }],
                avatar:  [{ required: true, message: '头像必填' }],
                phone: [
                    { required: true, message: '手机号必填' },
                    { validator: tel }
                ]
            }
        },

        genderList() {
            return this.gender.toList()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return userView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info

        if (!this.canSave) {
            this.$modal.updateBtns([
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        } else {
            this.$modal.updateBtns([
                { type: 'primary', text: '确定', name: 'confirm' },
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        }

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([roleList(), this.fetch()])
                .then(args => {
                    var [role, view] = args
                    if (role) {
                        this.orgOptions = role.data.list
                    }
                    if (view) {
                        var viewData = view.data
                        if (!viewData.superior || viewData.superior == 0) {
                            viewData.superior = ''
                            viewData.superiorName = ''
                        }
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                        let ids = viewData.superior.split(',') || [],
                            names = viewData.superiorName.split(',') || []
                        for (let i = 0; i < ids.length; i++) {
                            this.empOptions.push({
                                id: ids[i],
                                nickname: names[i]
                            })
                        }
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)

                    if (this.id) {
                        return userUpdate(formData)
                    } else {
                        return userAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
